import React, { FC, ReactElement } from 'react'
import styles from './Value.module.css'
import useSatoshiPriceUSD from '@/utils/hooks/useSatoshiPriceUSD'
import useSatoshiPrice from '@/utils/hooks/useSatoshiPrice'
import CircleLoading from '@/components/circle-loading'
import BitcoinIcon from '@/icons/bitcoin-filled'
import classnames from 'classnames'
import useUSDToggle from '@/utils/hooks/useUSDToggle'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const Value: FC<{
	className?: string
	iconClassName?: string
	skeleClassName?: string
	satoshis: number
	force?: 'USD' | 'BTC'
	isLoading?: boolean
}> = (props): ReactElement => {
	const price = useSatoshiPrice(props?.satoshis)
	const [priceUSD, isLoadingPriceUSD] = useSatoshiPriceUSD(props?.satoshis)
	const [showUSD, setShowUSD] = useUSDToggle()

	let isLoading =
		props?.isLoading ?? (typeof price === 'undefined' || showUSD ? isLoadingPriceUSD : false)

	let value = showUSD ? `$${priceUSD}` : price

	if (props?.satoshis === 0 && !props?.isLoading) {
		value = showUSD ? '$0' : '0.0'
		isLoading = false
	}

	const icon =
		showUSD || isLoading ? (
			<div />
		) : (
			<div className={styles.iconContainer}>
				<BitcoinIcon className={props?.iconClassName ? props.iconClassName : styles.icon} />
			</div>
		)

	return (
		<div
			onClick={() => setShowUSD(!showUSD)}
			className={classnames(
				{ [props?.className as any]: props?.className },
				// 'text-sm',
				// 'semibold',
				styles.root
			)}
			role="button"
			tabIndex={0}
			onKeyDown={onKeyboardClick(() => setShowUSD(!showUSD))}
		>
			{isLoading ? <CircleLoading size={24} /> : value}
			{icon}
		</div>
	)
}

export default Value
